// src/pages/NetflixTitle.tsx
import React, { useEffect } from 'react';
import './NetflixTitle.css';
import { useNavigate } from 'react-router-dom';
import logoImage from '../src/images/logo-2.png';

const NetflixTitle: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Navigate after 3500ms (3.5s) to match the new animation duration
    const timer = setTimeout(() => {
      navigate('/browse');
    }, 3500); // Increased time to allow animation to complete

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="netflix-container">
      <img 
        src={logoImage} 
        alt="Custom Logo" 
        // Use the new, more descriptive animation class
        className="netflix-logo logo-animation" 
      />
    </div>
  );
};

export default NetflixTitle;